import { convertAnyToKg } from "../../../../../packagingSimulation/utils/weightConversion";

export interface PackagingMaterialWeight {
  materialWeight?: number | string;
  weightUnit?: number | string;
}

/**
 * GS1 base-unit total in kg:
 * unit size (converted to kg) + sum of single-unit packaging material weights (converted to kg).
 */
export const calculateBaseUnitTotalWeightKg = (
  unitSize: number,
  unitSizeWeightUnit: number,
  materials: PackagingMaterialWeight[] = []
): number => {
  let totalKg = convertAnyToKg(Number(unitSizeWeightUnit), Number(unitSize)) || 0;

  for (const material of materials) {
    totalKg += convertAnyToKg(
      Number(material.weightUnit),
      Number(material.materialWeight || 0)
    );
  }

  return totalKg;
};
